import gql from 'graphql-tag';

export const CREATE_DAILY_EXPENSE = gql`
  mutation createDailyExpense(
    $createDailyExpenseInput: CreateDailyExpenseInput!
    $createDailyExpenseItemsInputs: [CreateDailyExpenseItemInput!]!
  ) {
    createDailyExpense(
      createDailyExpenseInput: $createDailyExpenseInput
      createDailyExpenseItemsInputs: $createDailyExpenseItemsInputs
    ) {
      id
      date
      supplierId
      supplierData {
        id
        supplierName
        supplierCode
        address
        contact
        branchId
        status
        createdAt
        updatedAt
        deletedAt
      }
      subTotal
      dailyExpenseNo
      paymentMethod
      tax
      adjustment
      total
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;


export const UPDATE_DAILY_EXPENSE = gql`
  mutation updateDailyExpense(
    $updateDailyExpenseInput: UpdateDailyExpenseInput!
    $updateDailyExpenseItemInputs: [UpdateDailyExpenseItemInput!]!
  ) {
    updateDailyExpense(
      updateDailyExpenseInput: $updateDailyExpenseInput
      updateDailyExpenseItemInputs: $updateDailyExpenseItemInputs
    ) {
      id
      date
      supplierId
      supplierData {
        id
        supplierName
        supplierCode
        address
        contact
        branchId
        status
        createdAt
        updatedAt
        deletedAt
      }
      subTotal
      dailyExpenseNo
      paymentMethod
      tax
      adjustment
      total
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;


export const REMOVE_DAILY_EXPENSE = gql`
  mutation removeDailyExpense($id: Int!) {
    removeDailyExpense(id: $id)
  }
`;
